import { filter } from 'rxjs';

export const filterNullish = filter((val: any) => !!val);
